import React, { createContext, useContext, useRef } from "react";

interface CameraContextType {
  openCamera: (cb: (file: File | null) => void) => void;
}

const CameraContext = createContext<CameraContextType | null>(null);

export const useCamera = () => {
  return useContext(CameraContext)!;
};

export const CameraInputProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const callbackRef = useRef<(file: File | null) => void>(() => {});

  const openCamera = (cb: (file: File | null) => void) => {
    callbackRef.current = cb;
    inputRef.current?.click();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    callbackRef.current(file);
    e.target.value = "";
  };

  return (
    <CameraContext.Provider value={{ openCamera }}>
      {children}

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        style={{ display: "none" }}
        onChange={handleChange}
      />
    </CameraContext.Provider>
  );
};
